import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getPosts } from "./index";
import "../Style/Accueil.ObsidianAura.css";
import "../Style/Blog.css";

export default function BlogList() {
  const { i18n, t } = useTranslation("blog");
  const posts = useMemo(() => getPosts({ lang: i18n.language }), [i18n.language]);

  return (
    <main className="life-home blog">
      <div className="hiw-bg" />
      <div className="life-home__overlay" />

      <section className="life-section">
        <div className="life-container">
          <div className="life-glass blog-hero">
            <h1 className="life-h1">{t("list.title", "Blog")}</h1>
            <p className="life-lead">{t("list.subtitle", "Idées, updates produit, vision.")}</p>
          </div>

          <div className="blog-grid">
            {posts.map((p) => (
              <Link key={p.slug} className="life-glass blog-card" to={`/blog/${p.slug}`}>
                {p.cover && <img className="blog-cover" src={p.cover} alt={p.title} loading="lazy" />}
                <div className="blog-cardBody">
                  <div className="blog-meta">
                    <span>{new Date(p.date).toLocaleDateString()}</span>
                    <span>•</span>
                    <span>{p.readingMinutes} min</span>
                  </div>
                  <div className="blog-title">{p.title}</div>
                  <div className="blog-excerpt">{p.excerpt}</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
